import { buildCssClassName } from "@/3514/utils"

import "./styles.scss"

type Props = {
    className?: string
}

export const SimulabTipBadge = ({ className = "" }: Props) => {
    return <span className={buildCssClassName("simulab-tip-badge", className)}>TIP</span>
}
